import { MenuItem } from "@blueprintjs/core";
import React from "react";
export default function ChatsoundsResult({ onClick, result, }) {
    const handleClick = React.useCallback(() => {
        onClick(result);
    }, [onClick, result]);
    return React.createElement(MenuItem, { onClick: handleClick, text: result });
}
